import React, { type FC } from 'react';

import { Frame } from './frame';
import { useTemplateEditorStore } from './store';
import { EditorViewMode } from './types';

export const Stage: FC = () => {
    const currentVariantIndex = useTemplateEditorStore((s) => s.currentVariantIndex);
    const editorViewMode = useTemplateEditorStore((s) => s.editorViewMode);
    const variants = useTemplateEditorStore((s) => s.template?.latestVersion.variants);

    return (
        <div className="flex flex-row flex-wrap flex-grow flex-shrink h-full bg-gray-800 p-6 justify-around items-center gap-6 overflow-auto">
            {variants &&
                variants?.length > 0 &&
                (editorViewMode === EditorViewMode.Grid ? (
                    variants.map((variant) => (
                        <Frame key={variant.id} variant={variant} width={300} />
                    ))
                ) : (
                    <Frame
                        key={variants[currentVariantIndex].id}
                        variant={variants[currentVariantIndex]}
                    />
                ))}
        </div>
    );
};
